export default function profile({ next, router, to }) {
    if (to.hash && to.name === 'profile.edit') {
        const type = to.hash.slice(1, to.hash.length);
        return router.push({ name: 'profile.edit', params: { type } });
    }
    return next();
}